module.exports = __webpack_public_path__ + "static/media/silver-band_720x480.f629c0fe.jpg";